/*
  Return true if the feature flag is present in the feature flags.
*/
export function haveFeatureFlag(
  featureFlags: string,
  flagName: string
): boolean {
  return featureFlags.split(';').includes(flagName);
}

export function featureFlagExperiments(featureFlags: string): {
  [name: string]: string;
} {
  const experimentsNameValuePair = featureFlags
    .split(';')
    .filter((experiment) => experiment.includes('='))
    .map((experiment) => experiment.split('='));

  const experiments: { [name: string]: string } = {};
  for (const experiment of experimentsNameValuePair) {
    const [name, value] = experiment;
    experiments[name] = value;
  }

  return experiments;
}
